<div *ngIf="challenges" class="core-sdg__sub-list">
  <h3 class="core-sdg__title">{{ title }}</h3>
  <ul class="core-sdg__list-sub">
    <ng-container *ngFor="let c of challenges">
      <li class="core-sdg__list__item is--active">
        <svg class="icon-svg icon-check" *ngIf="c !== 'None'">
          <use [attr.xlink:href]="'assets/gfx/svg-sprite.svg#icon-check'"></use>
        </svg>
        {{ c }}
      </li>
    </ng-container>
  </ul>
</div>
